/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 */
import { Component } from 'react'
import { Container } from 'flux/utils'
import { withRouter } from 'react-router'
import TaskEditView from '../../view/pages/tasks/TaskEditView'
import TaskEditStore from '../../store/task/TaskEditStore'
import TaskStore from '../../store/task/TaskStore'
import TaskAction from '../../action/task'

class TaskEditContainer extends Component {
  static getStores() {
    return [TaskEditStore, TaskStore]
  }

  static calculateState(prevState, props) {
    return {
      state: TaskEditStore.getState(),
      task: TaskStore.getState(),
      ...props
    }
  }

  componentDidMount() {
    const taskId = this.state.match.params.taskId
    if (taskId) {
      TaskAction.fetchOne(taskId)
    }
  }

  render() {
    return TaskEditView(this.state)
  }
}

export default withRouter(Container.create(TaskEditContainer, { withProps: true }))
